export default __webpack_public_path__ + "static/media/Honorary.6068b743.gif";